<template>
  <div>
    <el-row class="mb-20">
      <el-col :span="24">
        <el-table
          :data="registrations"

          style="width: 100%"
          stripe
          :row-class-name="getClassnameById"
          class="item-table hidden-sm-and-down"
        >
          <el-table-column type="expand" label=" " width=50>
            <template slot-scope="scope">
              <div class="ml-10">

                <fieldset v-if="scope.row.additionalQs.length !== 0" style="width: 450px">
                  <legend>Additional Questions</legend>
                  <p v-for="(value, name) in scope.row.meta" :key="name">
                    <span v-if="scope.row.additionalQs.length > 0" v-show="isShowableAnswer(name, scope.row.additionalQs)">
                      {{ getQuestion(name, scope.row.additionalQs) | startCase }}: {{ metaFormat(value) }}
                    </span>
                  </p>
                </fieldset>
                <div v-if="scope.row.productType !== 'legacy-membership'">
                  Product Type: {{scope.row.productType === 'indv' ? 'Individual'
                                  :scope.row.productType === 'indv-to-team' ? 'Individual To Team'
                                  :scope.row.productType === 'team' ? 'Team'
                                  :scope.row.productType === 'family' ? 'Family'
                                  : ''
                                   }}
                </div>
                <div v-if="scope.row.subProducts && scope.row.subProducts.length > 0">Sub Products: {{ joinTag(scope.row.subProducts) }}</div>
                <div v-if="scope.row.tags && scope.row.tags.length > 0">Tags: {{ joinTag(scope.row.tags) }}</div>
                <div>Status: {{ scope.row.expired ? 'Inactive': 'Active'}}</div>
                <div class="mb-10">
                  <span>Result: </span>
                  <div class="result-capture" v-if="Object.keys(scope.row.results).length" >
                    <div>{{ scope.row.results.name }}</div>
                    <div class="font-light">{{ scope.row.results.value }} ({{ getResultLabel(scope.row.results.type) }})</div>
                  </div>
                  <span v-else>Not Released Yet </span>
                </div>
                <div v-if="scope.row.payAfter" >
                  <div class="mb-10">Amount Paid: {{ priceFormatter(getAmountPaid(scope.row)) }}</div>
                  <div class="mb-10" v-if="!scope.row.payAfterMeta.fullyPaid && !scope.row.isPaid">Awaiting Payment: {{ priceFormatter(getAmountRemaining(scope.row)) }}</div>
                  <!-- button with paynow -->
                  <el-button class="mb-10" v-if="!scope.row.payAfterMeta.fullyPaid && !scope.row.isPaid" size="small" type="primary" @click=" makePayment(scope.row)" :key="key">
                    Pay Now
                  </el-button>
                </div>
                <div v-if="get(scope, 'row.regoEntity.isRenewable') && scope.row.productType !== 'family' && !alreadyRenew(scope.row)" class="mb-10">
                  <!-- <div>Amount Paid: {{ priceFormatter(scope.row.payAfterMeta.amountPaid) }}</div> -->
                  <!-- <div v-if="!scope.row.payAfterMeta.fullyPaid">Awaiting Payment: {{ priceFormatter(scope.row.payAfterMeta.amountRemaining) }}</div> -->
                  <!-- button with paynow -->
                  <div class="renew">
                    <span slot="label">
                      Renewal
                      <el-tooltip class="item" effect="dark" :content="`If you choose to renew, per the membership setting your membership will be renewed for ${getRenewalDuration(scope.row)}`" placement="top-start">
                        <i class="el-icon-info info"/>
                      </el-tooltip>
                    </span>
                  </div>
                  <el-button  size="small" type="primary" @click=" makeRenewPayment(scope.row)" :disabled="value.isLocked" :key="key">
                    Renew Now
                  </el-button>
                </div>
                <div>
                  <div>Files Uploaded: </div>
                  <div v-for="([group, files]) in groupedUploads(scope.row.files)" :key="group">
                    <h5 class="mt-0 mb-0">{{ group }}</h5>
                    <el-upload
                      :auto-upload="false"
                      :ref="`uploadDesktop-${scope.row._id}-${group}`"
                      :file-list="files ? files.map(file => ({_id: file._id, name: `${file.originalName || file.fileName} Uploaded At: ${dateFormatter(file.createdAt)}`, url: file.path, registrationId: file.meta.registrationId, type: file.fileType})) : []"
                      :on-preview="previewUpload"
                      :on-change="(file, fileList) => handleChange(file, fileList, {
                        _id: files._id,
                        registrationId: scope.row._id,
                        additionalQuestion: group,
                        entityId: scope.row.entityId,
                        entityType: scope.row.entityType,
                        memberId: value._id,
                        type: 'additional-question',
                      })"
                      :on-error="onError"
                      :before-upload="beforeUpload"
                      :before-remove="removeFile"
                      action=""
                      :headers="uploadHeaders"
                      :accept="accept"
                      :disabled="getUploadExpiry(scope.row)"

                      >
                      <el-button
                      slot="trigger"
                      size="small"
                      type="primary"
                      v-if= "isNotExpired(scope.row)"
                      >
                        Add File(s)
                      </el-button>
                      <!-- <div class="el-upload__tip" slot="tip">{{ getUploadTip(scope.row, group) }}</div> -->
                    </el-upload>
                  </div>
                </div>
                <div v-if="nationalId === 4 && scope.row.productType == 'indv-to-team'">
                  <fieldset class="mt-10" v-if="scope.row.team.meta && scope.row.team.meta.captain" style="width: 450px">
                    <legend>Captain</legend>
                    <p>Captain: {{ scope.row.team.meta.captain.name || '-' }}</p>
                    <p>Email: {{ scope.row.team.meta.captain.email || '-' }}</p>
                    <p>Mobile: {{ scope.row.team.meta.captain.mobile || '-' }}</p>
                  </fieldset>
                  <fieldset class="mt-10" v-if="scope.row.team.meta && scope.row.team.meta.viceCaptain" style="width: 450px">
                    <legend>Vice Captain</legend>
                    <p>Vice Captain: {{ scope.row.team.meta.viceCaptain.name || '-' }}</p>
                    <p>Email: {{ scope.row.team.meta.viceCaptain.email || '-' }}</p>
                    <p>Mobile: {{ scope.row.team.meta.viceCaptain.mobile || '-' }}</p>
                  </fieldset>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Entity"
            min-width="250"
          >
              <template slot-scope="scope">
              <div class="break-word" >{{entityFormatter(scope.row)}}</div>
              <el-button size="small" v-if="isUpgradeEligible(scope.row)" type="primary" @click="handleDropdown(scope.row,'open')" :disabled="value.isLocked" :key="key">
                Upgrade Membership
              </el-button>
              <el-button class="mb-05" size="small" v-if="scope.row.entityType === 'membership' && get(scope, 'row.regoEntity.products.isUpgradeable') && scope.row.upgradingDropdown" type="danger" @click="handleDropdown(scope.row, 'close')" :key="key">
                Cancel
              </el-button>
              <el-cascader
               v-if="scope.row.entityType === 'membership' && get(scope, 'row.regoEntity.products.isUpgradeable') && scope.row.upgradingDropdown"
               v-model="scope.row.regoEntity.membershipToUpgrade"
               :options="getFilterdMemberships(get(scope, 'row.regoEntity.products.upgradeableMembershipList'))"
               :props="{label: 'name', value: '_id', children: 'products' }"
               clearable
               filterable
               size="medium"
               :show-all-levels="true"
               separator=" -> "
               @change="handleChangeMem(scope.row)">
               <template slot-scope="{ node, data }">
                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                  <span v-if="data.products">{{ data.name }}</span>
                  <template v-else>
                    <span>{{ getProductType(data.type) }}</span>
                    <el-tag size="mini" style="margin-left: 5px">{{ capitalize(data.memberType) }}</el-tag>
                  </template>
                </div>
              </template>
             </el-cascader>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="Registration Date"
            width="190"
            sortable
          >
            <template slot-scope="scope">
                {{ dateFormatter(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <!-- column for approval status -->
          <el-table-column
            prop="approvalStatus"
            width="170"
          >
          <template slot="header" >
    <span>Approval Status</span>
    <el-tooltip
      class="item"
      effect="dark"
      content="This membership / event is not approved unless the status of this registration has been adjusted to 'Approved'"
      placement="top"
    >
      <i class="el-icon-info" style="margin-left: 5px;"></i>
    </el-tooltip>
  </template>
            <template slot-scope="scope">
              {{ getApprovalStatus(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="deregistered"
            label="Deregistered"
            width="150"
            :formatter="(r, c, v)=> v ? 'Yes' : 'No' "
            sortable
          />

          <el-table-column
            prop="expiry"
            label="Expiry Date"
            width="150"
            :formatter="(r, c, v)=> v ? dateFormatter(v) : '' "
            sortable
          />
          <el-table-column
            prop="expired"
            label="Expired"
            width="150"
            :formatter="(r, c, v)=> getExpiry(r) "
            sortable
          />
          <el-table-column
            prop="entityType"
            label="Entity Type"
            :formatter="(r,c,v)=>capitalize(v)"
            width="150"
            sortable
          >
          </el-table-column>
          <el-table-column prop="season" label="Season" width="120">
          </el-table-column>
          <el-table-column
            prop="memberType"
            label="Member Type"
            :formatter="(r,c,v)=>capitalize(v)"
            min-width="150"
          >
          </el-table-column>
          <el-table-column label="Deregister" width="120">
            <template slot-scope="scope">
              <el-button v-if="get(scope, 'row.deregistrationRequest[0].status') === 'pending'"  size="small" type="danger" :disabled="true" @click="deregisterRequest(scope.row)">
                Pending
              </el-button>
              <el-button v-else-if="get(scope, 'row.deregistrationRequest[0].status') === 'success'"  size="small" type="danger" :disabled="true" @click="deregisterRequest(scope.row)">
                Deregistered
              </el-button>
              <el-button v-else  size="small" type="danger" :disabled="scope.row.deregistered || isExpired(scope.row) || deregistrationDisabled" @click="deregisterRequest(scope.row)">
                Request
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="Operations" width="335" align="center" fixed="right">
            <template slot-scope="scope">
            <div>
      <el-tooltip placement="top">
        <div slot="content">
          <span>Download Receipt</span>
        </div>
        <span>
          <el-button size="mini" type="danger" @click="downloadReceipt(scope.row)">
            <i class="el-icon-download"></i>
          </el-button>
        </span>
      </el-tooltip>

      <el-tooltip placement="top">
        <div slot="content">
          <span>Click here to update additional question answer</span>
          <!-- <span v-else> Currently registrations that have dependent questions are not updatable</span> -->
        </div>
        <span style="margin-left: 15px">
          <el-button size="mini" type="danger" @click="showAQDialog(scope.row)">
            <i class="el-icon-edit-outline"></i>
          </el-button>
        </span>
      </el-tooltip>

      <el-tooltip placement="top">
        <div slot="content">
          <span>Click here to update saleable items additional question answer</span>
          <!-- <span v-else> Currently registrations that have dependent questions are not updatable</span> -->
        </div>
        <span style="margin-left: 15px">
          <el-button size="mini" type="warning" @click="showAQDialogSI(scope.row)">
            <i class="el-icon-edit-outline"></i>
          </el-button>
        </span>
      </el-tooltip>

      <el-tooltip placement="top" v-if="scope.row.entityType === 'membership'">
        <div slot="content">
          <span>Download Membership Card</span>
        </div>
        <span style="margin-left: 15px">
          <el-dropdown size="mini" @command="downloadMSCard">
            <el-button type="danger">
              <i class="el-icon-postcard"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{value: scope.row, type:'pdf'}">Download as PDF</el-dropdown-item>
              <el-dropdown-item :command="{value: scope.row, type:'png'}" >Download as PNG</el-dropdown-item>
              <el-dropdown-item :command="{value: scope.row, type:'regenerate'}" >Regenerate Card</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </el-tooltip>
      <!-- place for image qr code -->
      <el-tooltip placement="top" v-if="scope.row.entityType === 'membership'">
        <div slot="content">
          <span>Click here to view QR Code</span>
        </div>
        <span style="margin-left: 15px">
          <el-button size="mini" type="danger" @click="showQRCode(scope.row)">
            <i class="el-icon-view"></i>
          </el-button>
        </span>
      </el-tooltip>

    </div>
  </template>
          </el-table-column>
        </el-table>
        <div v-if="breakpoint === 'mobile'">
          <div v-for="registration in registrations" :key="registration.id" class="mb-4" >
            <el-card class="box-card mb-10 br-05 highlight-card" shadow="always" >
              <div slot="header" class="header-container">
  <div class="d-flex justify-content-between align-items-center">
    <span class="entity-name">{{ entityFormatter(registration) }}</span>
    <div class="actions-container d-flex align-items-center gap-10">

      <el-dropdown class="more-actions-dropdown" trigger="click">
        <i class="el-icon-more"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-download" @click.native="downloadReceipt(registration)">
            Download Receipt
          </el-dropdown-item>
          <el-dropdown-item icon="el-icon-edit-outline" @click.native="showAQDialog(registration)">
            Update Additional Question
          </el-dropdown-item>
          <el-dropdown-item
            v-if="registration.entityType === 'membership'"
            icon="el-icon-postcard"
            @click.native="downloadMSCard({value: registration, type: 'pdf'})"
          >
            Download Membership Card as PDF
          </el-dropdown-item>
          <el-dropdown-item
            v-if="registration.entityType === 'membership'"
            icon="el-icon-postcard"
            @click.native="downloadMSCard({value: registration, type: 'png'})"
          >
            Download Membership Card as PNG
          </el-dropdown-item>
          <el-dropdown-item
            v-if="registration.entityType === 'membership'"
            icon="el-icon-full-screen"
            @click.native="showQRCode(registration)"
          >
            View QR Code
          </el-dropdown-item>
          <el-dropdown-item
            v-if="registration.entityType === 'membership'"
            icon="el-icon-refresh"
            @click.native="downloadMSCard({value: registration, type: 'regenerate'})"
          >
            Regenerate Card
          </el-dropdown-item>
          <el-dropdown-item icon="el-icon-delete" @click.native="deregisterRequest(registration)">
            Request Deregistration
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</div>
<div class="upgrade-section mb-10" v-if="isUpgradeEligible(registration) || registration.upgradingDropdown">
    <el-button
      size="small"
      v-if="isUpgradeEligible(registration)"
      type="primary"
      :disabled="value.isLocked"
      @click="handleDropdown(registration,'open')"
      :key="key"
    >
      Upgrade Membership
    </el-button>

    <div v-if="registration.entityType === 'membership' && get(registration, 'regoEntity.products.isUpgradeable') && registration.upgradingDropdown">
      <el-button
        class="mb-05"
        size="small"
        type="danger"
        @click="handleDropdown(registration, 'close')"
        :key="key"
      >
        Cancel
      </el-button>

      <el-cascader
        v-model="registration.regoEntity.membershipToUpgrade"
        :options="getFilterdMemberships(get(registration, 'regoEntity.products.upgradeableMembershipList'))"
        :props="{label: 'name', value: '_id', children: 'products' }"
        clearable
        filterable
        size="medium"
        :show-all-levels="true"
        separator=" -> "
        @change="handleChangeMem(registration)"
        class="w-100"
      />
    </div>
  </div>
              <div class="d-grid grid-cols-2 ">
                <div class="grid-item">
                  <div class="mb-05">
                    <!-- entity type -->
                    <!-- <i class="el-icon-s-custom"></i> -->
                    <el-tag size="mini">
                      {{ registration.entityType | startCase}}
                    </el-tag>
                  </div>
                  <div class="mb-05">
                    <i class="el-icon-user"></i>
                    Type: {{ registration.memberType | startCase }}
                  </div>
                  <div class="">
                    <i class="el-icon-date"></i>
                    Reg. :  {{ msDateFormatter(registration.createdAt) }}
                  </div>
                </div>
                <div class="grid-item text-right" >
                  <div class="mb-05" v-if="registration.approvalStatus === 'approved'">
                    <!-- status tag -->
                    <el-tag v-if="!get(registration, 'regoEntity.isRenewable')" :type="getType(registration)" size="mini" @click="handleStatusClicked(registration)">{{ getStatus(registration) }}</el-tag>
                    <el-popconfirm
                      v-else
                      confirm-button-text='Proceed'
                      cancel-button-text='No, Thanks'
                      icon="el-icon-question"
                      title="Do you want to renew this membership for 12 months?"
                      :disabled="value.isLocked"
                      @confirm="handleStatusClicked(registration)"
                    >
                      <el-tag  slot="reference" :type="getType(registration)" size="mini" >{{ getStatus(registration) }}</el-tag>
                    </el-popconfirm>
                  </div>
                  <div v-else>
                <div  class="mb-05">
                  <el-tag size="mini" type="warning">{{ getApprovalStatus(registration)}}</el-tag>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="This membership / event is not approved unless the status of this registration has been adjusted to 'Approved'"
                    placement="top"
                  >
                    <i class="el-icon-info" style="margin-left: 5px;"></i>
                  </el-tooltip>
                </div>
                </div>
                  <div class="grid-item mb-05">
                    <i class="el-icon-s-order"></i>
                    Season: {{ registration.season }}
                  </div>

                  <div class="grid-item">
                    <i class="el-icon-date"></i>
                    Exp. :  {{ msDateFormatter(registration.expiry) }}
                  </div>
                </div>
              </div>
              <transition
              @before-enter="beforeEnter"
              @enter="enter"
              @before-leave="beforeLeave"
              @leave="leave"
              name="expand">
              <div v-if="registration.expanded" class="expandable-content mt-10">
                <div v-if="registration.additionalQs.length !== 0">
                <h5>Additional Questions</h5>
                <p v-for="(value, name) in registration.meta" :key="name">
                  <span v-if="registration.additionalQs.length > 0" v-show="isShowableAnswer(name, registration.additionalQs)">
                    {{ getQuestion(name, registration.additionalQs) | startCase }}: {{ metaFormat(value) }}
                  </span>
                </p>
              </div>
              <div v-if="registration.productType !== 'legacy-membership'">
                Product Type: {{ productTypeFormatter(registration.productType) }}
              </div>
              <div class="mt-05" v-if="registration.subProducts && registration.subProducts.length > 0">Sub Products: {{ joinTag(registration.subProducts) }}</div>
              <div v-if="registration.tags && registration.tags.length > 0">Tags: {{ joinTag(registration.tags) }}</div>
              <!-- <div>Status: {{ registration.expired ? 'Inactive' : 'Active' }}</div> -->
              <div class=" mt-05">
                <span>Result: </span>
                <div v-if="Object.keys(registration.results).length">
                  <div>{{ registration.results.name }}</div>
                  <div class="font-light">{{ registration.results.value }} ({{ getResultLabel(registration.results.type) }})</div>
                </div>
                <span v-else>Not Released Yet</span>
              </div>
              <div class="mt-05" v-if="registration.payAfter">
                <div class="mb-10">Amount Paid: {{ priceFormatter(getAmountPaid(registration)) }}</div>
                <div class="mb-10" v-if="!registration.payAfterMeta.fullyPaid && !registration.isPaid">Awaiting Payment: {{ priceFormatter(getAmountRemaining(registration)) }}</div>
                <el-button class="mb-10" v-if="!registration.payAfterMeta.fullyPaid && !registration.isPaid" size="small" type="primary" @click="makePayment(registration)">
                  Pay Now
                </el-button>
              </div>
              <div v-if="get(registration, 'regoEntity.isRenewable') && registration.productType !== 'family' && !alreadyRenew(registration)" class="mb-10">
  <div class="renew">
    <span>
      Renewal
      <el-tooltip class="item" effect="dark" :content="`If you choose to renew, per the membership setting your membership will be renewed for ${getRenewalDuration(registration)}`" placement="top-start">
        <i class="el-icon-info info"/>
      </el-tooltip>
    </span>
  </div>
  <el-button size="small" type="primary" @click="makeRenewPayment(registration)" :disabled="value.isLocked">
    Renew Now
  </el-button>
</div>
              <!-- <div v-if="get(registration, 'regoEntity.isRenewable')" class="mb-10">
                <div class="renew">
                  Renewal
                  <el-tooltip class="item" effect="dark" content="If you choose to renew 12 months will be added to the registration end date of the membership" placement="top-start">
                    <i class="el-icon-info info"></i>
                  </el-tooltip>
                </div>
                <el-button size="small" type="primary" @click="makeRenewPayment(registration)">
                  Renew Now
                </el-button>
              </div> -->
              <div>
                    <div>Files Uploaded: </div>
                    <div v-for="([group, files]) in groupedUploads(registration.files)" :key="group">
                      <h5 class="mt-0 mb-0">{{ group }}</h5>
                      <el-upload
                        :auto-upload="false"
                        :ref="`uploadDesktop-${registration._id}-${group}`"
                        :file-list="files ? files.map(file => ({_id: file._id, name: `${file.originalName || file.fileName} Uploaded At: ${dateFormatter(file.createdAt)}`, url: file.path, registrationId: file.meta.registrationId, type: file.fileType})) : []"
                        :on-preview="previewUpload"
                        :on-change="(file, fileList) => handleChange(file, fileList, {
                          _id: files._id,
                          registrationId: registration._id,
                          additionalQuestion: group,
                          entityId: registration.entityId,
                          entityType: registration.entityType,
                          memberId: value._id,
                          type: 'additional-question',
                        })"
                        :on-error="onError"
                        :before-upload="beforeUpload"
                        :before-remove="removeFile"
                        action=""
                        :headers="uploadHeaders"
                        :accept="accept"
                        :disabled="getUploadExpiry(registration)"

                        >
                        <el-button
                        slot="trigger"
                        size="small"
                        type="primary"
                        v-if= "isNotExpired(registration)"
                        >
                          Add File(s)
                        </el-button>
                        <!-- <div class="el-upload__tip" slot="tip">{{ getUploadTip(scope.row, group) }}</div> -->
                      </el-upload>
                    </div>
                  </div>
                  </div>
                  </transition>
                  <!-- Arrow icon at the bottom -->
                  <div class="expand-arrow" @click="toggleExpand(registration)">
                    <i :class="`el-icon-arrow-${registration.expanded ? 'up' : 'down'}`"></i>
                  </div>
            </el-card>
          </div>
        </div>
      </el-col>
    </el-row>
    <additional-qs-dialog v-if="showQsDialog" @updateFiles="updateFiles" @updateMeta="updateMeta" @closeDialog="closeDialog" v-model="latestDialogValue" :registration="latestDialogValue.registration" />
    <additional-qs-dialog-saleable-item
      v-if="showQsDialogSI"
      @closeDialog="closeDialogSI"
      v-model="latestDialogValueSI"
      :registration="latestDialogValueSI.registration"
    />
    <el-dialog
      :title="`${get(selectedRego, 'name')}`"
      :visible.sync="familyMSDialog"
      width="30%"
      >
      <div style=" overflow-x: auto;">
        <el-table
          style="width: 100%"
          :data="familyMSList">
          <el-table-column
            prop="gender"
            label="Gender"
            width="100">
          </el-table-column>
          <el-table-column
            label="Member Type"
            width="120">
            <template v-slot="scope">
              {{ scope.row.memberType | cap }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ageFrom"
            label="Age From"
            width="100">
          </el-table-column>
          <el-table-column
            prop="ageTo"
            label="Age To"
            width="100">
          </el-table-column>
          <el-table-column width="200" label="Member">
            <template v-slot="scope">
              <el-select v-model="scope.row.memberId" placeholder="Select Member">
                <el-option v-for="e in scope.row.availableMembers" :label="`${e.profile.firstName} ${e.profile.lastName}`" :key="e._id" :value="e._id" />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <div class="member-btn d-flex justify-content-center flex-0 mt-15">
            <el-button @click="cancelFamilyRego" >Cancel</el-button>
            <el-button :disabled="!selectedMember" type="primary" class="color-highlight bd-0" @click="initRegoFamily(familyMSList)">Register</el-button>
          </div>
        </el-row>
      </div>
    </el-dialog>
    <renew-payment
  v-if="showRenewPayment"
  @closeDialog="closeDialog"
  v-model="latestDialogValue"
  :rego="latestDialogValue.registration"
/>
    <!-- el dialog to display qrcode -->
    <el-dialog
      :title="`Qr Code for membership card`"
      :visible.sync="showQrCodeDialog"
      width="10%"
      >
      <div style=" overflow-x: auto; width:100%">
        <div class="d-flex justify-content-center">
          <img :src="qrCode" alt="QR Code" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _, { startCase } from 'lodash';
import moment from 'moment-timezone';
import { calculateMemberAge } from '@/utils/helpers';
import { mapGetters } from 'vuex';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { clientNationalIds } from '@/utils/client-rules';
import { datadogRum } from '@datadog/browser-rum';
import { fileUploadAcceptString, resultTypes } from '../../../utils/constants';
import AdditionalQsDialog from './AdditionalQsDialog.vue';
import AdditionalQsDialogSaleableItem from './AdditionalQsDialogSaleableItem.vue';
import RenewPayment from './RenewPayment.vue';

export default {
  components: { AdditionalQsDialog, AdditionalQsDialogSaleableItem, RenewPayment },
  props: {
    value: Object,
  },
  data() {
    return {
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      key: 0,
      capitalize: _.capitalize,
      registrations: [],
      membershipToRegister: {},
      fileUploadAcceptString,
      get: _.get,
      showQsDialog: false,
      showRenewPayment: false,
      dialogValue: {
        filtersVisible: false,
        entityType: undefined,
        registration: undefined,
        regoDetails: undefined,
        member: undefined,
      },
      familyMSDialog: false,
      familyMSList: [],
      selectedFamilyMS: undefined,
      members: [],
      selectedRego: undefined,
      selectedFromRego: undefined,
      showQrCodeDialog: false,
      qrCode: '',
      breakpoint: 'desktop',
      showQsDialogSI: false,
      dialogValueSI: {
        filtersVisible: false,
        entityType: undefined,
        registration: undefined,
        regoDetails: undefined,
        member: undefined,
      },
    };
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    const resMembers = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
    this.members = resMembers.data.data;
    const { regoId, regoProductId } = this.$route.params;
    if (this.value?._id) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.get(`/assemble/api/v1/portal/registrations/members/${this.value._id}`)
        .then((res) => {
          this.registrations = _.map(res.data.data, (data) => ({ ...data, results: _.get(data, 'results.0', {}) }));
          this.registrations = this.registrations.map((rego) => _.assign(rego, { upgradingDropdown: false }));
          // eslint-disable-next-line no-restricted-syntax
          for (const membership of this.registrations) {
            if (_.get(membership, 'regoEntity.products') && membership.regoEntity.products.upgradeableMembershipList && membership.expired !== true) {
            // eslint-disable-next-line no-restricted-syntax
              for (const um of membership.regoEntity.products.upgradeableMembershipList) {
                if (um._id === regoId) {
                  const foundProduct = um.products.find((product) => product._id === regoProductId);
                  if (foundProduct) {
                    setTimeout(() => {
                      // eslint-disable-next-line prefer-destructuring
                      const position = (document.getElementsByClassName(`${membership._id}`))[0];
                      position.scrollIntoView({ behavior: 'smooth' });
                    }, 200);
                  }
                }
              }
            }
          }
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e);
          this.$store.commit('loading', false);
        });
    }
  },
  methods: {
    getProductType(type) {
      // eslint-disable-next-line no-nested-ternary
      return type === 'indv' ? 'Individual' : type === 'team' ? 'Team' : type === 'family' ? 'Family' : '';
    },
    getRenewalDuration(rego) {
      const { durationYear, durationMonth, durationDay } = rego.regoEntity;
      if (durationYear > 0) return `${durationYear} year${durationYear > 1 ? 's' : ''}`;
      if (durationMonth > 0) return `${durationMonth} month${durationMonth > 1 ? 's' : ''}`;
      if (durationDay > 0) return `${durationDay} day${durationDay > 1 ? 's' : ''}`;
      return '';
    },
    alreadyRenew(rego) {
      const renewedRego = this.registrations.find((r) => r.meta?.isRenewed && r.meta?.renewFrom === rego._id);
      if (renewedRego) return true;
      return false;
    },
    getApprovalStatus(rego) {
      const { approvalStatus } = rego;
      if (approvalStatus === 'pending') {
        return 'Pending';
      }
      if (approvalStatus === 'approved') {
        return 'Approved';
      }
      if (approvalStatus === 'declined') {
        return 'Declined';
      }
      return this.getStatus(rego);
    },
    isExpired(rego) {
      const { expiry, expired } = rego;
      const current = moment().valueOf();
      if (expired) return true;
      if (current > expiry) return true;
      return false;
    },
    getAmountPaid(rego) {
      const { payAfterMeta, offlinePayments } = rego;
      const amountPaidOffline = _.sumBy(offlinePayments, 'amount');
      return amountPaidOffline + payAfterMeta.amountPaid;
    },
    getAmountRemaining(rego) {
      const { payAfterMeta, offlinePayments } = rego;
      const amountPaidOffline = _.sumBy(offlinePayments, 'amount');
      return payAfterMeta.amountRemaining - amountPaidOffline;
    },
    handleResize() {
      if (window.innerWidth < 992) {
        this.breakpoint = 'mobile';
      } else {
        this.breakpoint = 'desktop';
      }
    },
    handleStatusClicked(registration) {
      const isRenewable = _.get(registration, 'regoEntity.isRenewable');
      if (isRenewable) {
        this.makeRenewPayment(registration);
      }
    },
    getStatus(registration) {
      const { expiry, regoEntity } = registration;
      if (_.get(registration, 'deregistered')) return 'Deregistered';
      if (_.get(registration, 'deregistrationRequest[0].status') === 'pending') return 'Deregister Request Pending';
      if (_.get(regoEntity, 'isRenewable') && !this.alreadyRenew(registration)) {
        return 'Renew Now';
      } if (_.get(regoEntity, 'isRenewable') && this.alreadyRenew(registration)) {
        return 'Renewed';
      }
      if (expiry) {
        const current = moment().valueOf();
        if (current > expiry) return 'Expired';
      }
      return 'Active';
    },
    getType(registration) {
      const { expiry, regoEntity } = registration;
      if (_.get(registration, 'deregistered')) return 'danger';
      if (_.get(registration, 'deregistrationRequest[0].status') === 'pending') return 'warning';
      if (_.get(regoEntity, 'isRenewable')) {
        return 'warning';
      }
      if (expiry) {
        const current = moment().valueOf();
        if (current > expiry) return 'danger';
      }
      return 'success';
    },
    beforeEnter(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = '0';
    },
    enter(el) {
      // This ensures the element is displayed during the transition
      // eslint-disable-next-line no-param-reassign
      el.style.display = 'block';
      // eslint-disable-next-line no-param-reassign
      el.style.overflow = 'hidden';
      // eslint-disable-next-line no-param-reassign
      el.style.height = `${el.scrollHeight }px`;
    },
    beforeLeave(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = `${el.scrollHeight }px`;
    },
    leave(el) {
      // Force a reflow, necessary to restart the animation
      // eslint-disable-next-line no-void
      void el.offsetHeight;
      // eslint-disable-next-line no-param-reassign
      el.style.height = '0';
    },
    toggleExpand(registration) {
      // Toggle the expanded state
      this.$set(registration, 'expanded', !registration.expanded);
    },
    productTypeFormatter(value) {
      // eslint-disable-next-line no-nested-ternary
      return value === 'indv' ? 'Individual'
        // eslint-disable-next-line no-nested-ternary
        : value === 'indv-to-team' ? 'Individual To Team'
          // eslint-disable-next-line no-nested-ternary
          : value === 'team' ? 'Team'
            : value === 'family' ? 'Family'
              : '';
    },
    getExpiry(row) {
      const { expiry, expired } = row;
      if (expired) return 'Yes';
      const expiryDate = moment(expiry).format('YYYY-MM-DD');
      const today = moment().format('YYYY-MM-DD');
      if (moment(expiryDate).isBefore(today)) return 'Yes';
      return 'No';
    },
    makeRenewPayment(rego) {
      // push to route partial payment
      // this.$router.push({ name: 'renew-payment', params: { rego, renew: true } });
      this.dialogValue = {
        filtersVisible: true,
        entityType: 'indv',
        registration: rego,
        regoDetails: this.registrations,
        member: this.value,
      };
      this.showRenewPayment = true;
    },
    async showQRCode(rego) {
      // show qr code using dialog
      if (!rego.files || rego.files.length === 0) {
        const findMsCard = await this.$http.get(`/assemble/api/v1/portal/registrations/${rego._id}/membership-card`);
        if (_.get(findMsCard, 'data.msCard.meta.qrCode')) {
          this.qrCode = findMsCard.data.msCard.meta.qrCode;
          this.showQrCodeDialog = true;
        } else {
          this.$message.error('No QR Code found');
        }
        return true;
      }
      const msCard = rego.files.find((file) => file.type === 'membership-card');
      if (!_.get(msCard, 'meta.qrCode')) return this.$message.error('No QR Code found');
      this.showQrCodeDialog = true;
      // eslint-disable-next-line no-return-assign
      this.qrCode = msCard ? msCard.meta.qrCode : '';
      return true;
    },
    showAQDialog(row) {
      this.dialogValue.filtersVisible = true;
      this.dialogValue.entityType = 'indv';
      this.dialogValue.registration = row;
      this.dialogValue.regoDetails = this.registrations;
      this.showQsDialog = true;
    },
    showAQDialogSI(row) {
      this.dialogValueSI.filtersVisible = true;
      this.dialogValueSI.entityType = 'indv';
      if (row.entityType === 'membership') {
        this.dialogValueSI.registration = _.get(row, 'pricing.membership.saleableItems[0]');
      } else {
        this.dialogValueSI.registration = _.get(row, 'pricing.event.saleableItems[0]');
      }
      this.dialogValueSI.regoDetails = this.registrations;
      this.dialogValueSI.row = row;
      this.showQsDialogSI = true;
    },
    closeDialog() {
      this.dialogValue = {
        filtersVisible: false,
      };
      this.showQsDialog = false;
      this.showRenewPayment = false;
    },
    closeDialogSI() {
      this.dialogValueSI = {
        filtersVisible: false,
      };
      this.showQsDialogSI = false;
    },
    updateMeta({ meta, regoId }) {
      const foundIndex = this.registrations.findIndex((rego) => rego._id === regoId);
      if (foundIndex >= 0) this.registrations[foundIndex].meta = meta;
    },
    updateFiles({ files, regoId }) {
      const foundIndex = this.registrations.findIndex((rego) => rego._id === regoId);
      if (foundIndex >= 0) this.registrations[foundIndex].files = files;
    },
    makePayment(rego) {
      // push to route partial payment
      const pathName = this.hasCustomEntity ? 'custom-partial-payment' : 'partial-payment';
      this.$router.push({ name: pathName, params: { id: rego._id } });
    },
    priceFormatter(value) {
      return `$${value / 100}`;
    },
    async deregisterRequest(row) {
      const confirm = await this.$confirm('By clicking yes a request will be sent to the administrator to confirm the deregistration and issue a refund.', {
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
      });

      if (confirm) {
        await this.$http.post('/assemble/api/v1/portal/deregistration-status/registration/request', {
          registrationId: row._id
        });
        // eslint-disable-next-line no-param-reassign
        const index = this.registrations.findIndex((rego) => rego._id === row._id);
        this.$set(this.registrations[index], 'deregistrationRequest', [{ status: 'pending' }]);

        this.$message.success('Request Sent!');

        this.$store.commit('loading', false);
      }
    },
    isShowableAnswer(name, questions) {
      const flattenQuestions = [];
      _.forEach((questions), (q) => {
        if (q.fieldName) {
          flattenQuestions.push({ type: q.type, question: q.question, fieldName: _.camelCase(q.fieldName) });
        }
        if (q.parentsDependentQsList && q.parentsDependentQsList.length) {
          _.forEach(q.parentsDependentQsList[0].children, (cq) => {
            flattenQuestions.push({ type: cq.type, question: cq.question, fieldName: _.camelCase(cq.fieldName) });
          });
        }
      });
      const question = _.find(flattenQuestions, (q) => (q.fieldName && q.fieldName === name));
      if (!question) return false;
      if (![1, 2].includes(question.type)) return false;
      return true;
    },
    isUpgradeEligible(rego) {
      if (rego.entityType === 'membership' && _.get(rego, 'regoEntity.products.isUpgradeable') && !rego.upgradingDropdown && !rego.expired) {
        const { dob, gender } = this.value.profile;
        const endOfYear = this.$store.getters['national/endOfYear'];
        const age = calculateMemberAge(dob, endOfYear);
        const membershipList = rego.regoEntity.products.upgradeableMembershipList;
        const checkEligible = membershipList.some((membership) => membership.products.some((product) => (age >= product.ageFrom && age <= product.ageTo && (product.gender === gender || product.gender === 'All')) || product.type === 'family' || (product.gender === 'Other' && (gender !== 'Male' || gender !== 'Female'))));
        return checkEligible;
      }
      return false;
    },
    getFilterdMemberships(upgradeableMembershipList) {
      const { dob, gender } = this.value.profile;
      const endOfYear = this.$store.getters['national/endOfYear'];
      const age = calculateMemberAge(dob, endOfYear);
      const list = _.cloneDeep(upgradeableMembershipList);
      list.forEach((membership) => {
        // eslint-disable-next-line no-param-reassign
        membership.products = membership.products.filter((product) => (age >= product.ageFrom && age <= product.ageTo && (product.gender === gender || product.gender === 'All')) || product.type === 'family' || (product.gender === 'Other' && (gender !== 'Male' || gender !== 'Female')));
      });
      console.log('list', list);
      return list;
    },
    async downloadReceipt(registration) {
      let charges = [];
      try {
        const response = await this.$http.get(`/assemble/api/v1/portal/registrations/${registration._id}/receipt`);
        charges = response.data.data;
      } catch {
        this.$message.error('An error occured while downloading receipt');
      }

      if (pdfMake.vfs === undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      if (!charges.length) this.$message.success('This registration did not incur any cost thus no receipt was found');

      let logo = '';
      let isURL = false;
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        logo = process.env.VUE_APP_LOGO;
        isURL = true;
      }

      const dd = await this.$http.post('/assemble/api/v1/portal/registrations/receipt-content', {
        member: this.value, charges, logo, isURL, type: 'member'
      });

      if (!isURL) {
        dd.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
        dd.data.data.images = { logo: await this.getBase64Logo() };
      }

      pdfMake.createPdf(dd.data.data).download(`${registration._id}-${dd.data.chargeId}.pdf`);
    },
    splitTextIntoLines(ctx, text, maxWidth) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const { width } = ctx.measureText(`${currentLine} ${word}`);

        if (width < maxWidth) {
          currentLine += ` ${word}`;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }

      lines.push(currentLine);
      return lines;
    },
    async generateMSCard(membershipDetails, memberProfilePics, entityPic) {
      const cardCanvas = document.createElement('canvas');
      cardCanvas.width = 500;
      cardCanvas.height = 300;
      const cardWidth = cardCanvas.width;
      const pageHeight = cardCanvas.height;
      const cardContext = cardCanvas.getContext('2d');
      const lineSpacing = 22;
      const columnSpacing = 260;
      const lineWidth = 2;
      let isLogoURL = false;
      let isProfileURL = false;
      let isEntityURL = false;

      let logoImage;
      let profileImage;
      let entityImage;
      let logoPromise; let profilePromise; let
        entityPromise;
      const promises = [];

      // Load Logo Image
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        isLogoURL = true;
      }
      if (memberProfilePics && memberProfilePics !== '') {
        isProfileURL = true;
      }
      if (entityPic && entityPic !== '') {
        isEntityURL = true;
      }
      if (isLogoURL) {
        const logoContent = await this.$http.post('/assemble/api/v1/portal/registrations/image-content', { logo: process.env.VUE_APP_LOGO, isURL: true });
        logoImage = new Image();
        logoImage.src = logoContent.data.data.imageContent;
        // eslint-disable-next-line no-return-assign
        logoPromise = new Promise((resolve) => logoImage.onload = resolve);
        promises.push(logoPromise);
      }
      if (isProfileURL) {
        const profileContent = await this.$http.post('/assemble/api/v1/portal/registrations/image-content', { memberProfile: memberProfilePics, isURL: true });
        profileImage = new Image();
        profileImage.src = profileContent.data.data.memberImageContent;
        // eslint-disable-next-line no-return-assign
        profilePromise = new Promise((resolve) => profileImage.onload = resolve);
        promises.push(profilePromise);
      }
      if (isEntityURL) {
        const entityContent = await this.$http.post('/assemble/api/v1/portal/registrations/image-content', { entityLogo: entityPic, isURL: true });
        entityImage = new Image();
        entityImage.src = entityContent.data.data.entityImageContent;
        // eslint-disable-next-line no-return-assign
        entityPromise = new Promise((resolve) => entityImage.onload = resolve);
        promises.push(entityPromise);
      }

      await Promise.all(promises);

      // eslint-disable-next-line no-return-assign, no-param-reassign
      // await Promise.all([logoImage, memberProfilePics, entityPic].map((image) => new Promise((resolve) => image.onload = resolve)));

      // Draw the card background with border radius on the canvas
      cardContext.fillStyle = '#fff';
      cardContext.beginPath();
      cardContext.moveTo(20, 0);
      cardContext.lineTo(cardWidth - 20, 0);
      cardContext.quadraticCurveTo(cardWidth, 0, cardWidth, 20);
      cardContext.lineTo(cardWidth, pageHeight - 20);
      cardContext.quadraticCurveTo(cardWidth, pageHeight, cardWidth - 20, pageHeight);
      cardContext.lineTo(20, pageHeight);
      cardContext.quadraticCurveTo(0, pageHeight, 0, pageHeight - 20);
      cardContext.lineTo(0, 20);
      cardContext.quadraticCurveTo(0, 0, 20, 0);
      cardContext.closePath();
      cardContext.fill();

      // Draw the card border
      // Add border to the card
      cardContext.lineWidth = 2; // Set the border thickness
      cardContext.strokeStyle = '#000'; // Set the border color
      cardContext.stroke(); // Draw the border

      // Draw member profile logo on the top left
      const profileLogoWidth = 100;
      const profileLogoHeight = 100;
      const profileLogoX = 10;
      const profileLogoY = 10;
      cardContext.globalAlpha = 1;
      if (profileImage) {
        cardContext.drawImage(profileImage, profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      } else {
        cardContext.fillStyle = '#888';
        cardContext.fillRect(profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      }

      // Draw entity logo on the top right
      const entityLogoWidth = 100;
      const entityLogoHeight = 100;
      const entityLogoX = cardWidth - entityLogoWidth - 10;
      const entityLogoY = 10;

      if (entityImage) {
        cardContext.drawImage(entityImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      } else {
        cardContext.drawImage(logoImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      }

      const maxLineWidth = 260; // Maximum line width in pixels for the first level text

      // Draw entity created first level limited and second level limited in the top middle
      // First level with h2-like font size and black color
      cardContext.font = 'bold 22px BrownStd-Regular';
      cardContext.fillStyle = '#000'; // Black color
      // Adjust the starting Y position for the text to be closer to the top, with a small margin
      const textStartX = profileLogoX + profileLogoWidth + 10; // Start text from the right edge of the profile photo with a 10px margin
      const entityTextY = profileLogoY + 20; // Start text 10px below the top edge of the profile logo

      // Use the splitTextIntoLines function to handle potentially long text for the first level
      const firstLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedFirstLevelLimited, maxLineWidth);
      firstLevelLines.slice(0, 2).forEach((line, index) => { // Ensure only up to 2 lines are drawn for the first level
        cardContext.fillText(line, textStartX, entityTextY + (index * 25));
      });

      // Calculate Y position for second level based on how many lines were used for first level
      const secondLevelStartY = entityTextY + (firstLevelLines.length * 25) + 5; // Adjust Y position as needed for second line, with some spacing

      // Draw entity created second level limited in gray color and normal font size, potentially split into 2 lines
      cardContext.font = '16px BrownStd-Regular'; // Normal size for second level
      cardContext.fillStyle = '#888'; // Gray color for second level

      // Use the splitTextIntoLines function for the second level as well
      const secondLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedSecondLevelLimited, maxLineWidth);
      secondLevelLines.slice(0, 2).forEach((line, index) => { // Ensure only up to 2 lines are drawn for the second level
        cardContext.fillText(line, textStartX, secondLevelStartY + (index * 20));
      });

      // Draw membership details at the bottom
      cardContext.fillStyle = '#000';
      cardContext.font = 'bold 22px BrownStd-Regular';
      const membershipNameLines = this.splitTextIntoLines(cardContext, `${membershipDetails.membershipName}`, 450);
      membershipNameLines.forEach((line, index) => {
        cardContext.fillText(line, 10, pageHeight - 150 + index * lineSpacing);
      });

      // // a line to display entity name
      // cardContext.font = '16px BrownStd-Regular';
      // cardContext.fillStyle = '#888';
      // cardContext.fillText(`${membershipDetails.entity}`, 10, pageHeight - 150 + 1 * lineSpacing); // Adjust the vertical position as needed

      // first column
      cardContext.font = '18px BrownStd-Regular';
      // membership details label, gray text color
      cardContext.fillStyle = '#aaa';
      cardContext.fillText('Membership Details', 10, pageHeight - 150 + 2 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillStyle = '#000';
      cardContext.font = '16px BrownStd-Regular';
      // cardContext.fillText(`Entity: ${membershipDetails.entity}`, 10, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member Type: ${membershipDetails.memberType}`, 10, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Season: ${membershipDetails.season}`, 10, pageHeight - 150 + 4 * lineSpacing); // Adjust the vertical position as needed
      // eslint-disable-next-line no-nested-ternary
      const expiryText = membershipDetails.deregistered || membershipDetails.expired
        ? 'Expired'
        : membershipDetails.expiry
          ? `Exp: ${this.msDateFormatter(membershipDetails.expiry)}`
          : '';
      cardContext.fillText(`${expiryText}`, 10, pageHeight - 150 + 5 * lineSpacing); // Adjust the vertical position as needed

      // Draw vertical line between columns
      cardContext.beginPath();
      cardContext.moveTo(columnSpacing - 20, pageHeight - 150 + 2 * lineSpacing);
      cardContext.lineTo(columnSpacing - 20, pageHeight - 150 + 6 * lineSpacing);
      cardContext.lineWidth = lineWidth;
      cardContext.strokeStyle = '#888';
      cardContext.stroke();

      // second column
      cardContext.font = '18px BrownStd-Regular';
      // membership details label, gray text color
      cardContext.fillStyle = '#aaa';
      cardContext.fillText('Member Details ', columnSpacing, pageHeight - 150 + 2 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillStyle = '#000';
      cardContext.font = '16px BrownStd-Regular';
      cardContext.fillText(`Name: ${membershipDetails.memberName}`, columnSpacing, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member ID: ${membershipDetails.memberId}`, columnSpacing, pageHeight - 150 + 4 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member Number: ${membershipDetails.memberNumber}`, columnSpacing, pageHeight - 150 + 5 * lineSpacing); // Adjust the vertical position as needed
      const dobFormat = +process.env.VUE_APP_NATIONAL_ID === 15 ? 'YYYY' : 'DD/MM/YYYY';
      cardContext.fillText(`DOB: ${moment(membershipDetails.memberDob).format(dobFormat)}`, columnSpacing, pageHeight - 150 + 6 * lineSpacing); // Adjust the vertical position as needed

      // Reset alpha for the entity logo
      // Draw card watermark (background image)
      cardContext.globalAlpha = 0.1;
      cardContext.drawImage(logoImage, 0, 0, cardWidth, pageHeight);
      cardContext.globalAlpha = 1;

      // create a new image object
      return new Promise((resolve) => {
        cardCanvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/png');
      });
    },
    async downloadMSCard(val) {
      const { type, value: registration } = val;
      let confirmText = 'Membership card is not available yet. Do you want to generate it now?';
      if (type === 'regenerate') {
        confirmText = 'Do you want to regenerate the Membership Card?';
      }

      const msCardRes = await this.$http.get(`/assemble/api/v1/portal/registrations/${registration._id}/membership-card`);
      let msCard = msCardRes.data.data;
      const hasMsCard = msCard && msCard !== '';
      const msCardDetails = msCardRes.data.msCard;
      if (msCardDetails) {
        // check meta field newChange
        if (msCardDetails.meta.newChange) {
          confirmText = 'Membership details have been updated. Select yes to generate a new Membership Card.';
        }
      }
      if (!hasMsCard || msCardDetails.meta.newChange || type === 'regenerate') {
        this.$confirm(confirmText, 'Confirm', {
          distinguishCancelAndClose: true,

          confirmButtonText: 'Yes',

          cancelButtonText: 'No',
        })
          .then(async () => {
            this.$store.commit('loading', true);
            const currMember = this.members.find((member) => member._id === registration.memberId);

            const currentSeason = this.$store.getters['national/currentSeason'];
            const currMemberProfilePic = _.get(currMember, 'meta.imgUrl');
            const entityPic = _.get(registration, 'regoEntity.meta.imgUrl');
            const memberMembership = this.$store.getters['user/getActiveMemberRegos'];
            const { orgtree } = registration;
            let expectedExpiryDate;
            if (registration.renewFrom) {
              const renewalRego = _.find(memberMembership, (r) => r._id === registration.renewFrom);
              if (renewalRego) {
                expectedExpiryDate = renewalRego.expiry;
              }
            }
            // Manually create an array in the desired order from lowest to highest
            const orderedOrgtree = [
              orgtree.club, // Start with the lowest level
              orgtree.association,
              orgtree.state,
              orgtree.national
            ].filter((org) => org !== undefined); // This will remove any undefined levels, in case some levels do not exist

            const entityCreatedFirstLevel = orderedOrgtree[0] ? orderedOrgtree[0].name : '';
            const entityCreatedSecondLevel = orderedOrgtree[1] ? orderedOrgtree[1].name : '';
            const entityCreatedFirstLevelLimited = entityCreatedFirstLevel.length > 67 ? `${entityCreatedFirstLevel.substring(0, 67)}...` : entityCreatedFirstLevel;
            const entityCreatedSecondLevelLimited = entityCreatedSecondLevel.length > 77 ? `${entityCreatedSecondLevel.substring(0, 77)}...` : entityCreatedSecondLevel;

            // Reverse the array to start from club and then move up, and take the first two entities
            // const entityCreated = orderedOrgtree.slice(0, 2).map((org) => org.name).join(', ');
            // const entityCreatedLimited = entityCreated.length > 45 ? `${entityCreated.substring(0, 45)}...` : entityCreated;
            const getExpiryDate = () => {
              if (registration.useDuration) {
                if (expectedExpiryDate) {
                  return moment(expectedExpiryDate)
                    .add(registration.durationYear, 'year')
                    .add(registration.durationMonth, 'month')
                    .add(registration.durationDay, 'day')
                    .valueOf();
                }

                return moment()
                  .add(registration.durationYear, 'year')
                  .add(registration.durationMonth, 'month')
                  .add(registration.durationDay, 'day')
                  .valueOf();
              }
              return _.get(registration, 'endDate') || _.get(registration, 'expiry');
            };
            const membershipDetails = {
              membershipName: registration.fromImport ? 'Legacy Membership' : registration.regoEntity.name,
              membershipId: registration.fromImport ? '0' : registration.regoEntity._id,
              expiry: getExpiryDate(),
              memberType: registration.memberType,
              season: currentSeason,
              memberId: registration.memberId,
              memberName: `${currMember.profile.firstName} ${currMember.profile.lastName}`,
              memberDob: currMember.profile.dob,
              memberNumber: _.get(currMember, 'meta.memberNumber', ''),
              entityCreatedFirstLevelLimited,
              entityCreatedSecondLevelLimited,
              deregistered: registration.deregistered,
              expired: registration.expired,
            };
            msCard = await this.generateMSCard(membershipDetails, currMemberProfilePic, entityPic);
            // get presigned url
            const presignedUrl = await this.$http.post('/assemble/api/v1/portal/membership-card/presigned-url',
              {
                fileName: `membership-card-${registration.memberId}-${registration.entityId}-${_.get(registration, 'regoEntity.products._id', '')}.png`,
                folder: 'membership-cards',
                membershipDetails,
                registrationId: registration._id,
                notFromRego: true,
                regenerating: !!msCardDetails?.meta?.newChange,
              });

            const { url, s3Path } = presignedUrl.data.data;

            if (s3Path) {
              _.assign(registration, { membershipCard: s3Path });
            }

            await fetch(url, {
              method: 'PUT',
              body: msCard,
              headers: { 'Content-Type': '*/*' },
            });
            this.$store.commit('loading', false);
            this.$message.success('Membership card has been generated successfully');
          })
          .catch((e) => {
            datadogRum.addError(e, {
              message: 'Error generating membership card',
              tags: { feature: 'membership-card' }
            });
          });
        return;
      }
      // msCard is in base64 format already
      if (type === 'png') {
        const link = document.createElement('a');
        link.download = `${registration._id}.png`;

        // Convert to blob with base64
        const blob = this.dataURItoBlob(msCard);
        const blobUrl = URL.createObjectURL(blob);
        // Set the link href to the blob url
        link.href = blobUrl;
        // Append the link to the body
        document.body.appendChild(link);
        // Trigger the click event on the link
        link.click();
      } else if (type === 'pdf') {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        const dd = {
          content: [
            { image: msCard, width: [300], alignment: 'center' },
          ],
        };
        pdfMake.createPdf(dd).download(`${registration._id}.pdf`);
      }
    },

    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mimeString });
    },
    async getImageBase64(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.src = url;
      });
    },
    getResultLabel: (type) => _.find(resultTypes, { type }).label,
    beforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    onError(error) {
      if (error.message) {
        const json = JSON.parse(error.message);
        this.$message.error(json.message || 'There has been an error');
      } else {
        this.$message.error('There has been an error');
      }
    },
    entityFormatter(row) {
      if (!row.fromImport) {
        if (row.team && row.team.name) return `${row.team.name} - ${_.get(row, 'regoEntity.name')}`;
        return _.get(row, 'regoEntity.name');
      }
      return row.meta.productName || '';
    },
    dateFormatter(timestamp) {
      return moment(timestamp).tz(this.timezone).format('DD MMM YYYY, HH:mm');
    },
    msDateFormatter(timestamp) {
      // return in this type mm/yyyy
      return moment(timestamp).tz(this.timezone).format('DD/MM/YYYY');
    },
    handleChangeMem(rego) {
      const registrations = this.$store.getters['cart/registrations'];
      const [id, productId] = _.get(rego, 'regoEntity.membershipToUpgrade');
      const memberId = this.value._id;
      this.$confirm('Are you sure you want to upgrade this membership?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
        .then(() => {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post(`/assemble/api/v1/portal/registrations/search/entities/${id}/products/${productId}`)
            .then((res) => {
              const { result, transactionFee } = res.data.data;
              const [resutObject] = result;
              // eslint-disable-next-line no-param-reassign
              this.membershipToRegister = resutObject;
              const {
                _id: entityId, productType, memberType, ageFrom, ageTo
              } = this.membershipToRegister;

              if (resutObject.productType === 'family') {
                this.checkFamily(resutObject, rego);
              } else {
                this.membershipToRegister = resutObject;

                const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && r.memberType === memberType);
                if (foundRego) this.$message.error('Registration for this member has already been added to cart.');
                else {
                  this.$store.commit('cart/setTransactionFee', transactionFee);
                  // eslint-disable-next-line no-param-reassign
                  delete rego.upgradingDropdown;
                  const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
                  this.$router.push({
                    name: pathName,
                    params: { memberId, selectedMembership: this.membershipToRegister, upgradeFromMembership: rego },
                  });
                }
                this.$store.commit('loading', false);
              }
            }).catch((e) => {
              datadogRum.addError(e, {
                message: 'Error upgrading membership',
                tags: { feature: 'membership-upgrade' }
              });
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        })
        .catch(() => {});
    },
    async handleChange(file, fileList, config) {
      const fileIndex = fileList.findIndex((fl) => fl.name === file.name);
      try {
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        const res = await this.$http.post('/assemble/api/v1/portal/files/presigned-url', { fileName: file.name });
        const { url, name } = res.data.data;
        await fetch(url, {
          method: 'PUT',
          body: file.raw,
          headers: { 'Content-Type': '*/*' },
        });
        const nameOnly = name.split('.')[0];
        const fileTypeOnly = name.split('.')[name.split('.').length - 1];
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].name = nameOnly;
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].type = fileTypeOnly;
        this.$store.commit('loading', false);
      } catch (e) {
        this.$message.error('There has been an error');
      }
      this.$store.commit('loading', { loading: true, text: 'Loading...' });

      // After uploading via s3 presigned url, update file-uploads collection
      this.$http.post(this.fileUpdateUrl, {
        originalName: file.raw.name.split('.')[0],
        fileName: file.name,
        fileType: file.type,
        ...config
      }).then((res) => {
        const { fileId, fileName } = res.data.data;
        this.$message.success('File uploaded successfully');
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex]._id = fileId;
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].name = `${fileName} Uploaded At: ${this.dateFormatter(this.moment())}`;
      }).catch((e) => {
        datadogRum.addError(e, {
          message: 'Error uploading file',
          tags: { feature: 'file-upload' }
        });
        this.$message.error('There has been an error uploading the file');
      }).finally(() => {
        this.$store.commit('loading', false);
      });
    },
    removeFile(file) {
      const fileId = file._id;
      if (fileId) {
        return this.$confirm('You are about to permanently delete this file. Are you sure you want to continue?', 'Warning', { type: 'warning' })
          .then(() => {
            this.$store.commit('loading', { loading: true, text: 'Loading...' });
            this.$http.delete(`/assemble/api/v1/portal/files/${fileId}`)
              .then(() => {
                this.$message.success('Success!');
                this.$store.commit('loading', false);
              })
              .catch(() => {
                this.$message.error('Error deleting file');
                this.$store.commit('loading', false);
              });
          })
          .catch();
      } if (file) {
        // Catch for when the file hasn't been uploaded yet
        return true;
      }
      return false;
    },
    getUploadExpiry(rego) {
      const { entityType } = rego;
      if (entityType === 'event') {
        const [event] = rego.event;
        const { regoEndDate, isActive } = event;
        if (moment().valueOf() <= regoEndDate && isActive) return false;
        return true;
      }
      return false;
    },
    getUploadTip(rego, field) {
      const question = rego.additionalQs.find((q) => q.fieldName === field);
      return question
        ? question.question
        : 'Uploaded files must be 10mb or less';
    },
    submitUpload(ref) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      const uploadComponent = this.$refs[ref][0];
      uploadComponent.submit();
    },
    previewUpload(file) {
      const { _id } = file;
      this.$http.get(`/assemble/api/v1/portal/files/${_id}/signed`)
        .then((res) => {
        // Ask the user if they want to open the file
          this.$confirm('Do you want to view the file?', 'Confirm', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning'
          }).then(() => {
          // User confirmed, open the link in a new tab
            window.open(res.data.url, '_blank');
          }).catch(() => {
          // User cancelled
            this.$message.info('File preview cancelled.');
          });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    groupedUploads(data) {
      const grouped = _.groupBy(data, (file) => file.meta.additionalQuestion);
      const out = Object.keys(grouped).map((group) => ([group, grouped[group]]));
      return out;
    },
    isNotExpired(rego) {
      if (+this.moment() <= _.get(rego, 'event[0].regoEndDate') && _.get(rego, 'event[0].isActive')) {
        return true;
      }
      return false;
    },
    handleDropdown(rego, val) {
      if (val === 'open') {
        // eslint-disable-next-line no-param-reassign
        rego.upgradingDropdown = true;
      } else {
        // eslint-disable-next-line no-param-reassign
        rego.upgradingDropdown = false;
      }
      this.key++;
    },
    getClassnameById({ row }) {
      return `${row._id}`;
    },
    joinTag(vals) {
      return vals ? _.join(_.map(vals, (v) => v.name), ', ') : '';
    },
    getQuestion(metaName, additionalQs) {
      const flattenQuestions = [];
      _.forEach((additionalQs), (q) => {
        if (q.fieldName) {
          flattenQuestions.push({ question: q.question, fieldName: _.camelCase(q.fieldName) });
        }
        if (q.parentsDependentQsList && q.parentsDependentQsList.length) {
          _.forEach(q.parentsDependentQsList[0].children, (cq) => {
            flattenQuestions.push({ question: cq.question, fieldName: _.camelCase(cq.fieldName) });
          });
        }
      });
      const aQ = flattenQuestions.find((data) => data.fieldName === metaName);
      return _.get(aQ, 'question');
    },
    metaFormat(value) {
      if (value && _.isArray(value)) return _.join(value, ', ');
      return value;
    },
    getBase64Logo() {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = `${ this.logo }?r=${ Math.floor(Math.random() * 100000)}`;
      });
    },
    checkFamily(rego, fromRego) {
      this.selectedRego = rego;
      this.selectedFromRego = fromRego;
      this.familyMSList = _.get(rego, 'products[0].familyMS');
      _.forEach(this.familyMSList, (fms) => {
        // eslint-disable-next-line no-param-reassign
        fms.availableMembers = this.getAvailableMembers(fms);
      });
      this.familyMSDialog = true;
    },
    initRegoFamily(familyProduct) {
      const mappedFamilyRego = _.map(familyProduct, (fp) => ({
        ...this.selectedRego,
        ...fp,
        _id: this.selectedRego._id,
        gender: fp.gender,
        ageFrom: fp.ageFrom,
        ageTo: fp.ageTo,
        memberType: fp.memberType,
        productId: _.get(this, 'selectedRego.products[0]._id'),
        products: [
          {
            ...this.selectedRego.products[0],
            gender: fp.gender,
            ageFrom: fp.ageFrom,
            ageTo: fp.ageTo,
            memberType: fp.memberType,
            familyProductId: fp._id,
          }
        ]
      }));

      this.selectedRego.familyRego = mappedFamilyRego;

      const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
      this.$router.push({
        name: pathName,
        params: { selectedMembership: this.selectedRego, upgradeFromMembership: this.selectedFromRego },
      });
    },
    cancelFamilyRego() {
      _.each(this.familyMSList, (fam) => {
        // eslint-disable-next-line no-param-reassign
        fam.memberId = undefined;
      });
      this.familyMSDialog = false;
      this.selectedFamilyMember = false;
    },
    getAvailableMembers(product) {
      const members = _.filter(this.members, (member) => {
        const endOfYear = this.$store.getters['national/endOfYear'];
        const memberAge = calculateMemberAge(member.profile.dob, endOfYear);
        return memberAge >= product.ageFrom || memberAge <= product.ageTo || (member.profile.gender === product.gender);
      });

      // required memberships
      const requiredMSProducts = _.map(this.selectedRego.products[0].membershipProductsRequired, (ms) => ms.products._id);

      const mappedMembers = [];

      if (requiredMSProducts && requiredMSProducts.length) {
        _.forEach(members, (member) => {
          const mappedProductId = _.map(member.registration, (rego) => rego.productId);
          const intersection = _.intersection(requiredMSProducts, mappedProductId);
          if (intersection.length === requiredMSProducts.length) mappedMembers.push(member);
        });
      }
      return _.get(this, 'selectedRego.products[0].isMembershipRequired') ? mappedMembers : members;
    },
  },
  computed: {
    deregistrationDisabled() {
      const misc = this.$store.getters['national/getMisc'] || {};
      const enabled = misc?.deregistrationEnabled ?? true;
      return !enabled;
    },
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    latestDialogValue() {
      return this.dialogValue;
    },
    latestDialogValueSI() {
      return this.dialogValueSI;
    },
    logo() {
      // eslint-disable-next-line global-require
      const logo = process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '' ? process.env.VUE_APP_LOGO : require('@/assets/logos/Assemble_Logo_RGB_Positive.png');
      // eslint-disable-next-line global-require
      const logoMark = process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Positive.png');
      return logo || logoMark;
    },
    nationalLogoMark() {
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Mono_Positive.png');
    },
    nationalLogoOnly() {
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_ONLY && process.env.VUE_APP_LOGO_ONLY !== '' ? process.env.VUE_APP_LOGO_ONLY : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Mono_Positive.png');
    },
    customMemberDetailForm() {
      const nationalId = _.includes(clientNationalIds, +process.env.VUE_APP_NATIONAL_ID) ? process.env.VUE_APP_NATIONAL_ID : 0;
      // eslint-disable-next-line
      return () => import('@/views/app/clients/' + nationalId + '-member-profile-extras.vue');
    },
    accept() {
      return fileUploadAcceptString;
    },

    isNSWISA() {
      return +process.env.VUE_APP_NATIONAL_ID === 1;
    },
    memberIdLabel() {
      return +process.env.VUE_APP_NATIONAL_ID === 1 ? 'NSWISA Member ID' : 'Member ID';
    },
    fileUpdateUrl() {
      return `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/registration`;
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
    selectedMember() {
      const hasSelected = _.every(this.familyMSList, (fm) => fm.memberId !== undefined);

      return hasSelected;
    },
  },
  filters: {
    startCase,
    cap(value) {
      return _.capitalize(value);
    },
    formatDate(date) {
      return moment(date).tz(this.timezone).format('DD MMM YYYY, HH:mm');
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-popconfirm__main{
  word-break:break-word;
}
::v-deep .el-cascader-node__postfix {
  position: absolute;
  right: 10px;
}

::v-deep .el-cascader-node__label {
  width: 100%;
}
::v-deep .el-card__header {
  background: linear-gradient(90deg, #f6f8fa, #f6f8fa);
  padding: 0.5rem 0.75rem;
  position: relative;
  // &::after {
  //   // highlight line
  //   content: '';
  //   position: absolute;
  //   width: 5px;
  //   height: 100%;
  //   background: var(--secondary-color);
  //   left: 0%;
  //   top: 0%;
  //   transform: translate(0%, 0%);

  // }

  // color: white;
}
::v-deep .el-card__body {
  padding: 0.75rem 0.75rem 0.5rem 0.75rem;

}
.highlight-card {
  // background: white;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

}

.box-card {
  box-shadow: rgba(50, 50, 105, 0.1) 0px 2px 3px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  // border:0.5px solid rgba(0, 0, 0, 0.2);
    .expand-arrow {
      margin-top: 0.5rem;
  text-align: center;
  cursor: pointer;
  // padding: 10px;
  }

/* Transition effects */
.expand-enter-active, .expand-leave-active {
  transition: max-height 0.2s ease;
}

.expand-enter, .expand-leave-to /* .expand-leave-active in <2.1.8 */ {
  max-height: 0;
}

/* Initial state for the expandable content */
.expandable-content {
  max-height: 500px; /* Adjust this value based on your content's size */
  overflow: hidden;
  transition: height 0.5s ease;

}

  }
::v-deep .el-dropdown{
  display: inline-block
}
::v-deep .el-button{
  padding: 7px 15px !important;
}
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #f6f8fa !important;
    padding-right: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    padding-top: 2em;
    text-align: left;
  }
}

::v-deep .el-table__expanded-cell{
  padding-left:20px;
}

</style>
